import React, { useEffect } from 'react';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CardContent,
  IconButton,
} from '@material-ui/core';
import { Remove } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { setData } from '../../../redux';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';
import { asyncFetch, sortByDate } from '../../../../helperFunctions';

export default () => {
  const data = useSelector(state => state.tasks.data);
  const startedTaskId = useSelector(state => state.tasks.taskStarted.taskId);
  const task = data.tasks.find(x => x.id === startedTaskId);

  if (!task) return null;
  const taskIndex = data.tasks.indexOf(data.tasks.find(x => x.id === task.id));
  const installationProtocol = task ? task.installationProtocol : null;
  const documentsDashboard = task ? task.documentsDashboard : null;
  const { deinstalledDevices } = installationProtocol;
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const fontSize = width <= 500 ? '4vw' : '20px';

  useEffect(() => {
    if (!installationProtocol.isAllClientDevicesLoaded) {
      (async () => {
        const response = await asyncFetch(
          `${process.env.REACT_APP_TECHNICIANS_API}/documents/get-recent-client-devices?taskId=${documentsDashboard.taskId}`,
          {},
          {},
          () =>
            setTimeout(() => {
              const updatedTask = {
                ...task,
                installationProtocol: {
                  ...installationProtocol,
                  isAllClientDevicesLoaded: false,
                },
              };

              const updatedTasks = [...data.tasks];
              updatedTasks.splice(taskIndex, 1, updatedTask);

              dispatch(
                setData({
                  ...data,
                  tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
                }),
                3000
              );
            }),
          dispatch
        );

        if (response && Object.keys(response)) {
          const updatedClientDevices = response.recentClientDevices.filter(x => !x.isCpeReturned);
          const updatedDeinstalledDevices = response.recentClientDevices.filter(
            x => x.isCpeReturned
          );

          const updatedTask = {
            ...task,
            installationProtocol: {
              ...installationProtocol,
              isAllClientDevicesLoaded: true,
              allClientDevices: updatedClientDevices,
              deinstalledDevices: updatedDeinstalledDevices,
            },
          };

          const updatedTasks = [...data.tasks];
          updatedTasks.splice(taskIndex, 1, updatedTask);

          dispatch(
            setData({
              ...data,
              tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
            })
          );
        }
      })();
    }
  }, [installationProtocol, documentsDashboard, data, taskIndex, task, dispatch]);

  return (
    deinstalledDevices &&
    deinstalledDevices.length > 0 && (
      <CardContent>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ fontSize }} size="small">
                Тип
              </TableCell>
              <TableCell style={{ fontSize }} size="small">
                Сер. номер
              </TableCell>
              <TableCell style={{ fontSize }} size="small">
                Кол.
              </TableCell>
              <TableCell style={{ fontSize }} size="small" />
            </TableRow>
          </TableHead>
          <TableBody>
            {deinstalledDevices &&
              deinstalledDevices.map(x => (
                <TableRow key={x.serialNumber || x.materialId}>
                  <TableCell style={{ fontSize }} size="small">
                    {x.type}
                  </TableCell>
                  <TableCell style={{ fontSize }} size="small">
                    {x.serialNumber}
                  </TableCell>
                  <TableCell style={{ fontSize }} size="small">
                    {x.quantity}
                  </TableCell>
                  <TableCell style={{ fontSize }} size="small">
                    <IconButton
                      onClick={() => {
                        // todo remove installed device
                        const updatedDeinstalledDevices = [...deinstalledDevices];
                        updatedDeinstalledDevices.splice(deinstalledDevices.indexOf(x), 1);

                        const updatedTask = {
                          ...task,
                          installationProtocol: {
                            ...installationProtocol,
                            deinstalledDevices: updatedDeinstalledDevices,
                          },
                        };

                        const updatedTasks = [...data.tasks];
                        updatedTasks.splice(taskIndex, 1, updatedTask);

                        dispatch(
                          setData({
                            ...data,
                            tasks: updatedTasks.sort((a, b) => sortByDate(a, b)),
                          })
                        );
                      }}
                    >
                      <Remove />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </CardContent>
    )
  );
};
